import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({server: `refractometro`, endPoint: 'refractometro', method: 'GET', body: null, token: null, credentials: 'omit', mode: 'cors'})
}
